import { useEffect, useMemo, useState } from "react";
import { LoaderBoxCircular } from "../Components/LoaderBox";
import { Box, Container, Grid, TextField, MenuItem, Pagination } from "@mui/material";
import { UPSE8Item } from "../Components/UPSE8Item";
import { instance } from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";

const ESTADOS = ["Todos", "Pendiente de revisión", "Aprobado", "Rechazado"];
const POR_PAGINA = 5;

function UPSE8() {
  const { user } = useAuth();
  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({ title: "", text: "" });
  const [isLoading, setIsLoading] = useState(true);
  const [listaU8, setListaU8] = useState([]);

  const [filtroEstado, setFiltroEstado] = useState("Todos");
  const [filtroAnio, setFiltroAnio] = useState("Todos");
  const [pagina, setPagina] = useState(1);

  useEffect(() => {
    instance.get(`/upse8/listByUser?id=${user.id}`)
      .then((res) => setListaU8(res.data))
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message || "Error desconocido" });
        }
        setOpenDialog(true);
      })
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id]);

  const aniosDisponibles = useMemo(() => {
    const anios = [...new Set(listaU8.map((item) => item.anio))].sort((a, b) => b - a);
    return ["Todos", ...anios];
  }, [listaU8]);

  const listaFiltrada = useMemo(() => {
    return listaU8.filter((item) => {
      if (filtroEstado !== "Todos" && item.estado !== filtroEstado) return false;
      if (filtroAnio !== "Todos" && item.anio !== filtroAnio) return false;
      return true;
    });
  }, [listaU8, filtroEstado, filtroAnio]);

  const totalPaginas = Math.max(1, Math.ceil(listaFiltrada.length / POR_PAGINA));
  const listaPagina = listaFiltrada.slice((pagina - 1) * POR_PAGINA, pagina * POR_PAGINA);

  useEffect(() => {
    setPagina(1);
  }, [filtroEstado, filtroAnio]);

  return (
    <Container>
      <Box sx={{ marginTop: 4 }}>
        <h2 style={{ textAlign: 'center' }}>UPSE-8 - Reprogramación de metas físicas</h2>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <LoaderBoxCircular isLoading={isLoading}>
          <Container maxWidth="lg" sx={{ marginTop: 1, marginBottom: 5 }}>

            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  select fullWidth size="small" label="Estado"
                  value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}
                >
                  {ESTADOS.map((e) => <MenuItem key={e} value={e}>{e}</MenuItem>)}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  select fullWidth size="small" label="Año"
                  value={filtroAnio} onChange={(e) => setFiltroAnio(e.target.value)}
                >
                  {aniosDisponibles.map((a) => <MenuItem key={a} value={a}>{a}</MenuItem>)}
                </TextField>
              </Grid>
            </Grid>

            {listaFiltrada.length === 0 && !isLoading && (
              <Box sx={{ textAlign: 'center', marginTop: 4 }}>
                <p>No se encontraron formularios UPSE-8</p>
              </Box>
            )}

            {listaPagina.map((item, index) => (
              <UPSE8Item
                id={item.id}
                idUpse2={item.idUpse2}
                localidad={item.localidad}
                direccion={item.direccion}
                version={item.version}
                anio={item.anio}
                fechaPresentacion={item.fechaPresentacion}
                responsable={item.responsable}
                creado={item.creado}
                idCreado={item.idCreado}
                idResponsable={item.idResponsable}
                idUsuarioLogin={user.id}
                idEstado={item.idEstado}
                estado={item.estado}
                key={index}
              />
            ))}

            {listaFiltrada.length > POR_PAGINA && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Pagination
                  count={totalPaginas}
                  page={pagina}
                  onChange={(e, value) => setPagina(value)}
                  color="primary"
                />
              </Box>
            )}
          </Container>
        </LoaderBoxCircular>
      </Box>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </Container>
  );
}

export { UPSE8 }
